// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"bf56d191","585":"72bd99ef"}[chunkId] + ".chunk.js";
};